import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DropdownChangeEvent, DropdownModule } from 'primeng/dropdown';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Activity } from '../../../models/account/extra-curricular/activity/activityResponse';
import { DialogModule } from 'primeng/dialog';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CompleteProfileService } from '../../../services/account/complete-profile.service';
import { CalendarModule } from 'primeng/calendar';
@Component({
  selector: 'app-extra-currcular-activity',
  standalone: true,
  imports: [DropdownModule, CheckboxModule, DialogModule, FormsModule,
    InputTextareaModule, ButtonModule, InputTextModule, CommonModule, RadioButtonModule, ReactiveFormsModule, CalendarModule],
  templateUrl: './extra-currcular-activity.component.html',
  styleUrl: './extra-currcular-activity.component.scss'
})
export class ExtraCurrcularActivityComponent  {

  @Input() submitted: boolean = false;
  @Input() activity!: FormGroup;
  @Input() index!: number;
  @Output() remove: EventEmitter<number> = new EventEmitter<number>();
  @Input() activities: Activity[] | null | undefined;
  visible: boolean = false;

  gradeLevels = [
    { value: '9', label: '9' },
    { value: '10', label: '10' },
    { value: '11', label: '11' },
    { value: '12', label: '12' },
    { value: 'Grad', label: 'Grad' }
  ];

  constructor(private completeProfileService: CompleteProfileService) {

  }

  // Remove activity form group from form array
  removeActivity(index: number): void {
    this.remove.emit(index);
  }


  onActivityChange($event: DropdownChangeEvent, index: number): void {
    const selectedId = $event.value;
    const selectedActivity = this.activities?.find(activity => activity.id === selectedId);
    if (!selectedActivity) return;
  
    const tierControl = this.activity.get(`tier${index}`);
    const otherActivityControl = this.activity.get('otherActivityName');
  
    tierControl?.updateValueAndValidity();
  
    // Disable tier if "Internship"
    if (selectedActivity.name === 'Professionsal Job') {
      tierControl?.disable();
      tierControl?.reset();
    } else {
      tierControl?.enable(); 
    }
  
    if (otherActivityControl) {
      if (selectedActivity.name === 'Other') {
        otherActivityControl.setValidators([Validators.required]);
      } else {
        otherActivityControl.clearValidators();
      }
      otherActivityControl.updateValueAndValidity();
    }
  }

  // isTierDisabled(index: number): boolean {
  //   const selectedId = this.activity.get('activityId')?.value;
  //   const selectedActivity = this.activities?.find(a => a.id === selectedId);
  //   return selectedActivity?.name === 'Professionsal Job';
  // }


  showOtherActivity(activityId: number): boolean {
    const selectedActivity = this.activities?.find(activity => activity.id === activityId);
    if (selectedActivity && selectedActivity.name === 'Other') {
      return true;
    }
    return false;
  }

  showDialog() {
    this.visible = true;
  }
}
